<h1>{{ getText() || 'Überschrift' }}</h1>
